// bundle of HBS helpers used in an offer card HBS template
define('lib/helpers/offer-bundle',[
  'Handlebars',
  'lib/helpers/classify',
  'lib/helpers/cleanify',
  'lib/helpers/removePeriods',
  'lib/helpers/toJSON',
  'lib/helpers/if_eq',
  'lib/helpers/trimString',
  'lazyload',
  'dropkick',
  'textfit'
], function () {});

